module.exports = __webpack_public_path__ + "img/20-4.9386ba98.png";